"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrlByEnvironment = void 0;
const brandUrl_1 = require("./brandUrl");
const getUrlByEnvironment = (brand) => {
    if (process.env.NODE_ENV === 'development') {
        return brandUrl_1.brandUrl.localhost;
    }
    return brandUrl_1.brandUrl[brand];
};
exports.getUrlByEnvironment = getUrlByEnvironment;
